import { ApolloError } from '@apollo/client';

/** True when the backend rejected the request because of ERP-scope roles. */
export const isPermissionDeniedError = (error?: ApolloError): boolean =>
  Boolean(
    error?.graphQLErrors?.some((gqlError) =>
      /permission\s*denied/i.test(gqlError.message),
    ),
  );
